import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LivetourComponent } from './livetour';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {TranslateModule} from '../../translate-module';
import { BrowserModule } from '@angular/platform-browser';
import { HttpModule } from '@angular/http';
import {CompanyService} from '../../services/index';
@NgModule({
  declarations: [
    LivetourComponent
  ],
  imports: [
    BrowserModule,
    HttpModule,
    CommonModule,
    FormsModule,
    TranslateModule,
    ReactiveFormsModule,

    BrowserModule.withServerTransition({
      appId: 'angular-universal-firebase'
    }),


  ],
  providers: [
    CompanyService,


  ],
  exports: [
    LivetourComponent
  ]
})
export class LivetourModule { }



// WEBPACK FOOTER //
// C:/prj/liveplanet-app-site/src/app/components/livetour/livetour.module.ts